/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creating_Ad_Template_WaitInputs */

const en_creating_ad_template_wait = /** @type {(inputs: Creating_Ad_Template_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating AD template... please wait...`)
};

const fr_creating_ad_template_wait = /** @type {(inputs: Creating_Ad_Template_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création du modèle AD... veuillez patienter...`)
};

const de_creating_ad_template_wait = /** @type {(inputs: Creating_Ad_Template_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Vorlage wird erstellt... Bitte warten...`)
};

const it_creating_ad_template_wait = /** @type {(inputs: Creating_Ad_Template_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione del modello di annuncio... attendere prego...`)
};

const ru_creating_ad_template_wait = /** @type {(inputs: Creating_Ad_Template_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание шаблона объявления... пожалуйста, подождите...`)
};

const es_creating_ad_template_wait = /** @type {(inputs: Creating_Ad_Template_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando plantilla de AD... por favor espere...`)
};

const zh_cn2_creating_ad_template_wait = /** @type {(inputs: Creating_Ad_Template_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在创建广告模板……请稍候……`)
};

const ja_creating_ad_template_wait = /** @type {(inputs: Creating_Ad_Template_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD テンプレートを作成しています...お待ちください...`)
};

const hi_creating_ad_template_wait = /** @type {(inputs: Creating_Ad_Template_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD टेम्प्लेट बनाया जा रहा है... कृपया प्रतीक्षा करें...`)
};

const pt_pt2_creating_ad_template_wait = /** @type {(inputs: Creating_Ad_Template_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criando modelo de anúncio... aguarde...`)
};

/**
* | output |
* | --- |
* | "Creating AD template... please wait..." |
*
* @param {Creating_Ad_Template_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creating_ad_template_wait = /** @type {((inputs?: Creating_Ad_Template_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creating_Ad_Template_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creating_ad_template_wait(inputs)
	if (locale === "de") return de_creating_ad_template_wait(inputs)
	if (locale === "it") return it_creating_ad_template_wait(inputs)
	if (locale === "ru") return ru_creating_ad_template_wait(inputs)
	if (locale === "es") return es_creating_ad_template_wait(inputs)
	if (locale === "zh-CN") return zh_cn2_creating_ad_template_wait(inputs)
	if (locale === "ja") return ja_creating_ad_template_wait(inputs)
	if (locale === "hi") return hi_creating_ad_template_wait(inputs)
	if (locale === "pt-PT") return pt_pt2_creating_ad_template_wait(inputs)
	return en_creating_ad_template_wait(inputs)
});